import { Box, Container, Button, Typography, useTheme } from '@mui/material'
import EditProfile from '../pages/User/EditProfile'
import { useState } from 'react'
import LogoMark from '../assets/img/logo.svg?react'
import { useTranslation } from 'react-i18next'
import { logoutAndRedirect } from '../utils/logout'

const WelcomeProfileEdit = () => {
  const {t} = useTranslation()
  const theme = useTheme()
  // @ts-expect-error テーマの型が不明
  const header_height: string = theme.components.MuiToolbar.styleOverrides.root.height
  const [is_welcome, setIsWelcome] = useState(true)
  return is_welcome ?
    <Box sx={{
      position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, padding: '10px',
      textAlign: 'center', alignContent: 'center'
    }}>
      <LogoMark width='150px' height='100px'/><br/>
      <Typography variant='h4' fontWeight='bold' fontSize={20} mt={3}>
        {t('welcome.welcome')}
      </Typography>
      <p style={{whiteSpace: 'pre-wrap', margin: '34px 0', fontSize: '11pt'}}>
        {t('welcome.description')}
      </p>
      <Button
        onClick={()=> setIsWelcome(false)}
        variant='contained'
        sx={{px: 6}}
        startIcon={<span className='material-icons-outlined'>edit</span>}
      >
        {t('welcome.set_profile')}
      </Button>
    </Box>
  :
    <Container maxWidth='md' sx={{px: 0}}>
      <div style={{height: header_height}}/>
      <EditProfile is_init/>
      <Box textAlign='center' mt={12} mb={1}>
        <Typography fontSize={10} color='text.secondary'>
          {t('welcome.sign_out_description')}
        </Typography>
        <Button
          variant='text'
          onClick={()=> { logoutAndRedirect() }}
          size='small' color='safe'
          sx={{fontWeight: 'normal', fontSize: 11}}
        >
          {t('welcome.sign_out')}
        </Button>
      </Box>
    </Container>
}
export default WelcomeProfileEdit
